import React, { useState } from 'react';
import styled from 'styled-components';
import CreatorSidebar from './CreatorSidebar';
import { Menu, X, LogOut } from 'lucide-react'; 
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const Container = styled.div`
  display: flex;
  min-height: 100vh;
  background: var(--background-dark);
  position: relative;
`;

const MobileMenuButton = styled.button`
  display: none;
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1001;
  background: linear-gradient(95.36deg, #e0c16f 5.18%, #bd851b 93.21%);
  color: #000;
  border: none;
  border-radius: 50%;
  width: 56px;
  height: 56px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.5);
  cursor: pointer;
  align-items: center;
  justify-content: center;
  @media (max-width: 992px) {
    display: flex;
  }
`;

// DODATO: Dugme za Logout na mobilnom (gore desno)
const MobileLogoutButton = styled.button`
  display: none;
  position: fixed;
  top: 15px;
  right: 15px;
  z-index: 100;
  background: rgba(255, 71, 87, 0.1);
  color: #ff4757;
  border: 1px solid #ff4757;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 0.8rem;
  font-weight: 600;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  @media (max-width: 992px) {
    display: flex;
  }
`;

const SidebarWrapper = styled.div`
  @media (max-width: 992px) {
    position: fixed;
    top: 0;
    left: ${props => props.$isOpen ? '0' : '-100%'};
    height: 100vh;
    z-index: 1000;
    transition: left 0.3s ease-in-out;
    background: var(--background-dark);
    box-shadow: ${props => props.$isOpen ? '5px 0 15px rgba(0,0,0,0.5)' : 'none'};
  }
`;

const Main = styled.main`
  flex: 1;
  margin-left: 260px;
  min-height: 100vh;
  width: calc(100% - 260px);

  @media (max-width: 992px) {
    margin-left: 0;
    width: 100%;
  }
`;

const Content = styled.div`
  padding: 40px;
  max-width: 100%;
  overflow-x: hidden;

  @media (max-width: 768px) {
    /* POVEĆAN PADDING-TOP da "Welcome back" ne bi bio pod headerom */
    padding: 80px 16px 40px; 
  }
`;

const CreatorLayout = ({ user, activeSection, onNavItemClick, openNavItem, setOpenNavItem, children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleSelect = (item) => {
    onNavItemClick(item);
    setIsSidebarOpen(false); 
  };

  return (
    <Container>
      {/* Dugme za otvaranje menija (dole desno) */}
      <MobileMenuButton onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
        {isSidebarOpen ? <X size={24} /> : <Menu size={24} />}
      </MobileMenuButton>

      {/* Dugme za Logout (gore desno na mobilnom) */}
      <MobileLogoutButton onClick={handleLogout}>
        <LogOut size={16} /> Logout
      </MobileLogoutButton>

      <SidebarWrapper $isOpen={isSidebarOpen}>
        <CreatorSidebar 
          user={user} 
          activeSection={activeSection} 
          onNavItemClick={handleSelect} 
          openNavItem={openNavItem} 
          setOpenNavItem={setOpenNavItem} 
        />
        
        {/* Logout opcija unutar samog sidebara na dnu za mobilni */}
        {isSidebarOpen && (
            <div style={{padding: '20px', borderTop: '1px solid #333', marginTop: 'auto'}}>
                <button 
                    onClick={handleLogout}
                    style={{width: '100%', background: '#ff4757', color: '#fff', border: 'none', padding: '12px', borderRadius: '8px', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px'}}
                >
                    <LogOut size={20} /> Logout
                </button>
            </div>
        )}
      </SidebarWrapper>

      <Main>
        <Content>{children}</Content>
      </Main>
    </Container>
  );
};

export default CreatorLayout;